
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  UmbrellaCompanySignupRequest,
  ValidationError,
} from '../models';
import {
    UmbrellaCompanySignupRequestFromJSON,
    UmbrellaCompanySignupRequestToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface CreateRequest {
    umbrellaCompanySignupRequest: UmbrellaCompanySignupRequest;
}

/**
 * 
 */
export class UmbrellaCompanyCreationApi extends runtime.BaseAPI {

    /**
     * Creates an umbrella company
          */
    async createRaw(requestParameters: CreateRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['umbrellaCompanySignupRequest'] == null) {
            throw new runtime.RequiredError(
                'umbrellaCompanySignupRequest',
                'Required parameter "umbrellaCompanySignupRequest" was null or undefined when calling create().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/compliance/api/umbrella`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UmbrellaCompanySignupRequestToJSON(requestParameters['umbrellaCompanySignupRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Creates an umbrella company
          */
    async create(requestParameters: CreateRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.createRaw(requestParameters, initOverrides);
    }

}
